import useSWR from 'swr';

import { endpoints, fetcherGet } from 'src/lib/axios';

const REFRESH_INTERVAL = 5 * 60 * 1000; // 5 minutes

export function usePendingPaymentsCount() {
  const { data, error, isLoading, mutate } = useSWR(
    endpoints.orders.externals.pendingPaymentsCount,
    fetcherGet,
    { refreshInterval: REFRESH_INTERVAL }
  );

  return {
    count: (data ?? null) as number | null,
    loading: isLoading,
    error,
    refresh: mutate,
  };
}
